<template>
  <div class="v-button-group">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: "v-button-group",
}
</script>

<style lang="scss">
.v-button-group {
    display: flex;
    align-items: stretch;

    & > .con-vs-tooltip {
        &:first-child {
            .vs-component.vs-button {
                border-radius: 4px 0 0 4px;
            }
        }

        &:last-child {
            .vs-component.vs-button {
                border-radius: 0 4px 4px 0;
            }
        }
    }

    & > .vs-component.vs-button {
        border-radius: 0;

        &:first-child {
            border-radius: 4px 0 0 4px;
        }

        &:last-child {
            border-radius: 0 4px 4px 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Button/VButtonGroup.vue